import React from "react"

import { ButtonElement } from "@front-shared/elements/button.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import plusIcon from "@front-shared/assets/images/icons/plus-white.svg"
import refreshIcon from "@front-shared/assets/images/icons/refresh-dark2.svg"

export const ReviewNewRulesFloatingControlComponent: React.FunctionComponent<
    IReviewNewRulesFloatingControlComponentProps
> = props => {
    return (
        <div
            className="
                fixed bottom-[24px] horizontal-center flex items-center z-20
                bg-brand-white rounded-[100px]
                pl-[32px] py-[12px] pr-[12px]
                gap-[8px] min-w-[320px] max-w-[90vw]
                border border-solid border-brand-vibrantPurple
            "
        >
            <div className="flex items-center gap-[8px] flex-shrink-0">
                <span
                    className={`
                        flex-shrink-0 w-[20px] h-[20px] rounded-full flex items-center justify-center text-white text-[12px] font-bold
                        ${props.invalidCount ? "bg-brand-error2" : "bg-brand-green3"}
                    `}
                    aria-hidden
                >
                    {props.invalidCount ? "!" : "✓"}
                </span>

                <PrimaryText
                    typography="text"
                    size={14}
                    className="whitespace-nowrap"
                >
                    <span className="text-bold">
                        {props.invalidCount || props.validCount} of{" "}
                        {props.totalCount} rule
                        {props.totalCount > 1 ? "s" : ""}
                    </span>{" "}
                    {(props.invalidCount || props.validCount) === 1
                        ? "is"
                        : "are"}{" "}
                    {props.invalidCount ? "invalid" : "valid"}
                </PrimaryText>
            </div>

            <div className="flex items-center gap-[16px] flex-shrink-0">
                <ButtonElement
                    label="Re-upload CSV"
                    htmlType="button"
                    type="default"
                    onClick={props.onReuploadCsv}
                    icon={refreshIcon}
                    buttonClassName="!pl-[16px] !pr-[16px]"
                />

                {props.validCount ? (
                    <ButtonElement
                        label={`Add ${props.validCount} rules`}
                        htmlType="button"
                        type="primary"
                        onClick={props.onAddValidRules}
                        isLoading={props.isSubmitting}
                        icon={plusIcon}
                        buttonClassName="!pl-[16px] !pr-[16px]"
                    />
                ) : null}
            </div>
        </div>
    )
}

interface IReviewNewRulesFloatingControlComponentProps {
    invalidCount: number
    totalCount: number
    validCount: number
    onReuploadCsv: () => void
    onAddValidRules: () => void
    isSubmitting?: boolean
}
